import './gallery.less';
import './lg.less';
import './gallery';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import GalleryItem from './gallery-item';

const b = block('gallery');

const Gallery = ({list, hasCaption, fullWidth}) => {
	return (
		<div
			className={b({'has-caption':hasCaption, 'full-width': fullWidth}, 'js-gallery')}
			data-has-caption={hasCaption}
		>
			{
				list.map((item, index) => (
					<GalleryItem key={index} {...item} hasCaption={hasCaption} />
				))
			}
		</div>
	);
}

Gallery.propTypes = {
	list: PropTypes.array.isRequired,
	hasCaption: PropTypes.bool,
	fullWidth: PropTypes.bool
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/index.jsx